// extracted by mini-css-extract-plugin
module.exports = {"vanlife-roadtrips-R":"R_vanlife-roadtrips-R__U2KSt"};